// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  background: #181f2c !important;
  width: 80px !important;
  min-height: 100vh;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between;
  padding: 25px 18px;
  box-sizing: border-box !important;
  transition: all 0.5s ease !important;
}
.sidebar__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 25px;
}
.sidebar__logo {
  display: flex;
  align-items: center;
  justify-content: center;
}
.sidebar__logo svg {
  height: 30px;
  width: 40px;
}
.sidebar__menu {
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.29);
  padding-bottom: 20px;
}
.sidebar__menu .menuItem {
  padding: 15px 0;
  border-bottom: none;
  font-weight: 900;
  line-height: 12px;
  color: #ffffff;
  display: block;
}
.sidebar__menu .menuItem__link {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 18px;
  padding: 0 5px;
  background-color: transparent;
  transition: all 0.2s ease;
  cursor: pointer;
  margin: 0;
  width: 100%;
}
.sidebar__menu .menuItem__link span {
  font-size: 0;
  transition: all 0.5s ease;
  white-space: nowrap;
  opacity: 0%;
  text-align: left;
  margin: 0;
  padding: 0;
}
.sidebar__menu .menuItem__link svg {
  height: 22px;
  width: 22px;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 22px;
}
.sidebar__menu .menuItem__link:hover span {
  color: #42db89 !important;
}
.sidebar__menu .menuItem__link.activeMenu span {
  color: #42db89 !important;
}
.sidebar__menu .menuItem:last-child {
  border-bottom: none;
}
.sidebar--active {
  width: 250px !important;
}
.sidebar--active .userBlock__name {
  font-size: 14px !important;
  opacity: 100%;
}
.sidebar--active .userBlock__profile {
  font-size: 15px !important;
  opacity: 100%;
}
.sidebar--active .menuItem__link span {
  font-size: 12px;
  opacity: 100%;
}

.zoomMapIcon {
  position: absolute !important;
  right: 10px;
  top: 10px;
  color: #fff !important;
  height: 35px;
  width: 35px;
  min-width: 35px !important;
}

.pageWrapper {
  width: calc(100vw - 70px);
  transition: all 0.5s ease;
}

.sidebar.sidebar--active + div {
  width: calc(100vw - 250px);
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,sBAAA;EACA,iBAAA;EACA,wBAAA;EACA,iCAAA;EACA,8BAAA;EACA,kBAAA;EACA,iCAAA;EACA,oCAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AAEI;EACE,YAAA;EACA,WAAA;AAAN;AAIE;EACE,oDAAA;EACA,oBAAA;AAFJ;AAGI;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AADN;AAGM;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,cAAA;EACA,6BAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;AADR;AAGQ;EACE,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AADV;AAIQ;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AAFV;AAYU;EACE,yBAAA;AAVZ;AAcU;EACE,yBAAA;AAZZ;AAiBM;EACE,mBAAA;AAfR;AAoBE;EACE,uBAAA;AAlBJ;AAoBI;EACE,0BAAA;EACA,aAAA;AAlBN;AAqBI;EACE,0BAAA;EACA,aAAA;AAnBN;AAwBQ;EACE,eAAA;EACA,aAAA;AAtBV;;AA6BA;EACE,6BAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;AA1BF;;AA6BA;EACE,yBAAA;EACA,yBAAA;AA1BF;;AA6BA;EACE,0BAAA;AA1BF","sourcesContent":[".sidebar {\n  background: #181f2c !important;\n  width: 80px !important;\n  min-height: 100vh;\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: space-between;\n  padding: 25px 18px;\n  box-sizing: border-box !important;\n  transition: all 0.5s ease !important;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 25px;\n  }\n\n  &__logo {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    svg {\n      height: 30px;\n      width: 40px;\n    }\n  }\n\n  &__menu {\n    border-bottom: 0.5px solid rgba(255, 255, 255, 0.29);\n    padding-bottom: 20px;\n    .menuItem {\n      padding: 15px 0;\n      border-bottom: none;\n      font-weight: 900;\n      line-height: 12px;\n      color: #ffffff;\n      display: block;\n\n      &__link {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        gap: 18px;\n        padding: 0 5px;\n        background-color: transparent;\n        transition: all 0.2s ease;\n        cursor: pointer;\n        margin: 0;\n        width: 100%;\n\n        span {\n          font-size: 0;\n          transition: all 0.5s ease;\n          white-space: nowrap;\n          opacity: 0%;\n          text-align: left;\n          margin: 0;\n          padding: 0;\n        }\n\n        svg {\n          height: 22px;\n          width: 22px;\n          flex-grow: 0;\n          flex-shrink: 0;\n          flex-basis: 22px;\n        }\n\n        &:hover {\n          //   svg {\n          //     path,\n          //     rect {\n          //       fill: #42db89;\n          //     }\n          //   }\n          span {\n            color: #42db89 !important;\n          }\n        }\n        &.activeMenu {\n          span {\n            color: #42db89 !important;\n          }\n        }\n      }\n\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n  }\n\n  &--active {\n    width: 250px !important;\n\n    .userBlock__name {\n      font-size: 14px !important;\n      opacity: 100%;\n    }\n\n    .userBlock__profile {\n      font-size: 15px !important;\n      opacity: 100%;\n    }\n\n    .menuItem {\n      &__link {\n        span {\n          font-size: 12px;\n          opacity: 100%;\n        }\n      }\n    }\n  }\n}\n\n.zoomMapIcon {\n  position: absolute !important;\n  right: 10px;\n  top: 10px;\n  color: #fff !important;\n  height: 35px;\n  width: 35px;\n  min-width: 35px !important;\n}\n\n.pageWrapper {\n  width: calc(100vw - 70px);\n  transition: all 0.5s ease;\n}\n\n.sidebar.sidebar--active + div {\n  width: calc(100vw - 250px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
